// @Helpers
import DateHelper from 'utilities/dateHelper'
import { formatInterest } from 'utilities/currencyHelper'

// @Constants 
import { COUNTRIES_CODES } from 'constants/countries'
import { EURO_SYMBOL } from 'constants/index'
import DATE_FORMAT_TYPES from 'commonsConstants/dateFormatTypes'
import { DEPOSIT_PRODUCT, PRODUCT_COLORS } from 'constants/offers'
import { RENEWAL_DEPOSIT_HIRING_FLOW, RENEWAL_DEPOSIT_HIRING_FLOW_POST_EXPIRATION } from '../../deposits/constants/depositsConstants';

const { NL } = COUNTRIES_CODES

const getTypeProduct = (flowId) => {
    if ([RENEWAL_DEPOSIT_HIRING_FLOW, RENEWAL_DEPOSIT_HIRING_FLOW_POST_EXPIRATION].includes(flowId)) {
        return DEPOSIT_PRODUCT
    }
    return null
}

const getFormartedAmount = (amount, originCountry) => {
    const amountFormatted = formatInterest(amount, false)
    if (NL === originCountry) {
        return `${EURO_SYMBOL} ${amountFormatted}`
    }
    return `${amountFormatted} ${EURO_SYMBOL}`
}

const orderOffers = ({ offersValues: prevOffersValues }, {  offersValues: nextOffersValues }) => {
    const dateA = prevOffersValues.months || 0
    const dateB = nextOffersValues.months || 0
    return dateA - dateB
}

export const offersAdapter = ({ offers = [], originCountry }) => {
    const obectifiedOffers = offers.toJS ? offers.toJS() : offers;
    const productCounter = {}
    let isDepositExpired = false

    const newOffers = obectifiedOffers
        .sort(orderOffers)    
        .map((offer, index) => {
            const {
                flowId,
                tin,
                tae,
                offersValues: {
                    cancelMonths,
                    cancelCost,
                    exampleInterestAmountCancelled,
                    exampleInterestAmount,
                    grossInterest,
                    months,
                    exampleAmount,
                } = {},
                metadata: {
                    isTheMostProfitable,
                    contracts
                } = {}
            } = offer

            const productType = getTypeProduct(flowId)
            const productColor = PRODUCT_COLORS[productType]
            
            const { amount, closestExpirationDate, offerExpirationDate } = contracts[0] || {}
            const isExpired = flowId === RENEWAL_DEPOSIT_HIRING_FLOW_POST_EXPIRATION
            const expirationDate = isExpired ? offerExpirationDate : closestExpirationDate

            const amountFormatted = getFormartedAmount(amount, originCountry)
            const grossInterestFormatted = getFormartedAmount(grossInterest, originCountry)
            const exampleInterestAmountFormatted = getFormartedAmount(exampleInterestAmount, originCountry)
            const exampleAmountFormatted = getFormartedAmount(exampleAmount, originCountry)
            const exampleInterestAmountCancelledFormatted = getFormartedAmount(exampleInterestAmountCancelled, originCountry)

            if(!productCounter[productType]){
                productCounter[productType] = 1;
            } else {
                productCounter[productType] += 1;
            }
            const numberProduct = productCounter[productType];
            if (!isDepositExpired) {
                isDepositExpired = isExpired
            }

            return {
                ...offer,
                offerValues: {
                    tin: formatInterest(tin),
                    tae: formatInterest(tae),
                    amount: amountFormatted,
                    grossInterest: grossInterestFormatted,
                    months,
                    expirationDate: DateHelper.buildFormattedDate(expirationDate, DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_WITH_SLASHES), 
                    isTheMostProfitable,
                    color: productColor
                        ? PRODUCT_COLORS[productType][numberProduct - 1]
                        : PRODUCT_COLORS.default,
                },
                example: {
                    cancelCost: formatInterest(cancelCost),
                    cancelMonths,
                    exampleInterestAmountCancelled: exampleInterestAmountCancelledFormatted,
                    exampleInterestAmount: exampleInterestAmountFormatted,
                    exampleAmount: exampleAmountFormatted
                },
                productType,
                numberProduct,
                supIndex: index + 1,
                maxAmount: amount,
            }
        })

    return {
        isDepositExpired,
        offers: newOffers
    }
}
